import { ArrayUtils } from './ArrayUtils.ts';
(function(RandomUtils) {
    function randomIntBetween(minInclusive, maxInclusive) {
        return Math.floor(Math.random() * (maxInclusive - minInclusive + 1)) + minInclusive;
    }
    RandomUtils.randomIntBetween = randomIntBetween;
    function randomNumberBetweenFloat(minValue, maxValue) {
        return Math.random() * (maxValue - minValue) + minValue;
    }
    RandomUtils.randomNumberBetweenFloat = randomNumberBetweenFloat;
    function randomUniqueIndicesFromLength(length, uniqueIndicesNum) {
        const numbersSet = new Set();
        if (length === 0) return [];
        const tooManyIndicesRequested = uniqueIndicesNum > length;
        if (tooManyIndicesRequested) uniqueIndicesNum = length;
        for(let i = 0; i < uniqueIndicesNum; i += 1){
            const randomIndex = randomIntBetween(0, length - 1);
            if (numbersSet.has(randomIndex)) {
                i -= 1;
                continue;
            }
            numbersSet.add(randomIndex);
        }
        return Array.from(numbersSet);
    }
    RandomUtils.randomUniqueIndicesFromLength = randomUniqueIndicesFromLength;
    const allPossibleCharacters = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ];
    const ambiguousCharacters = [
        '1',
        'I',
        'l',
        'O',
        '0'
    ];
    const possibleCharacters = ArrayUtils.differenceOfTwoArrays(allPossibleCharacters, ambiguousCharacters);
    function randomStringId(length) {
        let text = '';
        for(let i = 0; i < length; i += 1){
            text += possibleCharacters[Math.floor(Math.random() * possibleCharacters.length)];
        }
        return text;
    }
    RandomUtils.randomStringId = randomStringId;
    function randomNumberExcept(minInclusive, maxInclusive, except) {
        const randomNo = randomIntBetween(minInclusive, maxInclusive);
        if (randomNo != except) {
            return randomNo;
        }
        return randomNumberExcept(minInclusive, maxInclusive, except);
    }
    RandomUtils.randomNumberExcept = randomNumberExcept;
    function randomBool() {
        return Math.random() >= 0.5;
    }
    RandomUtils.randomBool = randomBool;
    function randomAngle() {
        return Math.PI * 2 * Math.random();
    }
    RandomUtils.randomAngle = randomAngle;
    function randomSign() {
        return Math.random() < 0.5 ? -1 : 1;
    }
    RandomUtils.randomSign = randomSign;
    function randomNegativePositive(n) {
        return n * Math.random() * randomSign();
    }
    RandomUtils.randomNegativePositive = randomNegativePositive;
    function randomWeightedValue(values, weights) {
        const totalWeight = weights.reduce((a, b)=>a + b, 0);
        const randomWeight = Math.random() * totalWeight;
        let weightSum = 0;
        for(let index = 0; index < values.length; index += 1){
            weightSum += weights[index];
            if (randomWeight <= weightSum) {
                return values[index];
            }
        }
        const lastElementAsFallback = values[values.length - 1];
        return lastElementAsFallback;
    }
    // Source: github copilot
    RandomUtils.randomWeightedValue = randomWeightedValue;
})(RandomUtils || (RandomUtils = {}));
export var RandomUtils;
